import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";

export interface PrimarySCDto {
    userId: string;
    displayName: string;
}

export interface ParticipantSnapshotDto {
    participantId: number;
    name: string;
    avatarUrl: string;
    city: string;
    waiver: string;
    primarySC?: PrimarySCDto;
    status: string;
    cirCount: number;
    filesNeedingReview: number;
}

export const GetParticipantSnapshotAsync = async (
    token: string,
    participantId: number
): Promise<ApiResponse<ParticipantSnapshotDto>> => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/participants/participantId/${participantId}/snapshot`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch participant snapshot (status ${response.status})`);
    }

    const data = await response.json();
    return data;
};
